import { Model } from 'modules/core/lib/mobx-rest'

interface ITemplate {
  [key: string]: any
}

export class Template extends Model<ITemplate> {
  static urlRoot() {
    return '/custom_templates/templates'
  }
}
